import { connect } from "react-redux";
import { default as component } from "./ContentOrderStatusBadge.jsx";

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, null)(component);
